import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	genericErrorHeading: {
		id: 'fastshift.common.displays.generic-error.heading',
		defaultMessage: 'Something went wrong',
		description:
			'Heading for error message displayed when an unknown error occurs, for example 500 internal server error, or server returns empty data',
	},
	genericErrorGraphicAltText: {
		id: 'fastshift.common.displays.generic-error.graphic-alt-text',
		defaultMessage: 'Error Graphic',
		description:
			'Alt Text for the generic error vector graphic displayed when an unknown error occurs',
	},
	genericErrorGraphicAltTextDecorative: {
		id: 'fastshift.common.displays.generic-error.graphic-alt-text',
		defaultMessage: 'Decorative image',
		description:
			'alt text for the decorative error vector graphic displayed when an unknown error occurs',
	},
	defaultRefreshButtonLabel: {
		id: 'fastshift.common.displays.generic-error.refresh-button-label',
		defaultMessage: 'Refresh',
		description:
			'Label for the refresh button that when clicked, refetches the data from the server.',
	},
});
